export default __webpack_public_path__ + "static/media/q2_2_step1.e0c94dc2.png";